export class DownloadManager {
  static async downloadWithLink(url: string, nome: string) {
    try {
      const baseUrl = import.meta.env.VENTAS_BASE_URL
      const link = document.createElement('a')
      link.href = `${baseUrl}/api/v2/Arquivos/download?url=${url}`
      link.download = nome
      link.click()
    } catch (error) {
      console.warn('Erro ao baixar o arquivo:', error)
      throw error
    }
  }
}
